export default __webpack_public_path__ + "befecbb5542188d0c2e087d6b522983d.svg";